import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var CompressionAlgorithm = /** @class */ (function (_super) {
    __extends(CompressionAlgorithm, _super);
    function CompressionAlgorithm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompressionAlgorithm.$BgDEFLATE = 'deflate';
    CompressionAlgorithm.$BgLZMA = 'lzma';
    CompressionAlgorithm.$BgZLIB = 'zlib';
    return CompressionAlgorithm;
}(ASObject));
export { CompressionAlgorithm };
